import { Stack } from "./styles";

const ErrorStack = ({
    stack = [],
    complete = false
}) => {
    const getClassName = () => {
        const classList = ["custom-scrollbar primary"];
        complete && classList.push("complete");
        return classList.join(" ");
    }
    return (
        <Stack className={getClassName()}>
            <ol>
                {[...(complete ? stack : [...stack].slice(0, 10))].map(({ 
                    row, message 
                }, idx) => {
                    return (
                        <li key={idx}>
                            <strong>{idx + 1}. Error en la fila N°{row}: </strong>
                            {message}
                        </li>
                    );
                })}
                {(!complete && stack.length > 10) &&
                    <li>...</li>}
            </ol>
        </Stack>
    );
}

export default ErrorStack;